import React, { useEffect } from 'react';
import {
  createBrowserRouter,
  Outlet,
  RouterProvider,
  ScrollRestoration,
  useLocation,
} from "react-router-dom";
import ReactGA from 'react-ga4';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import CookieBanner from './components/CookieBanner/CookieBanner';
import LandingPage from './pages/LandingPage';
import WebdesignPage from './pages/WebdesignPage';
import WebshopsPage from './pages/WebshopsPage';
import OnlineMarketingPage from './pages/OnlineMarketingPage';
import SeoPage from './pages/SeoPage';
import WebsiteSpeedPage from './pages/WebsiteSpeedPage';
import AppDevPage from './pages/AppDevPage';
import SupportAndOptimizationPage from './pages/SupportAndOptimizationPage';
import ContactPage from './pages/ContactPage';
import PortfolioPage from './pages/PortfolioPage';
import AboutUsPage from './pages/AboutUsPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import StartProjectPage from './pages/StartProjectPage';
import AppsPrivacyPolicyListPage from './pages/AppsPrivacyPolicyListPage';
import AppsPrivacyPolicyDetailPage from './pages/AppsPrivacyPolicyDetailPage';
import PartnerPage from './pages/PartnerPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';


const AppLayout = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <CookieBanner />
      <ScrollRestoration />
    </>
  );
};

const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      {
        path: "/",
        element: <LandingPage />,
      },
      {
        path: "/webdesign",
        element: <WebdesignPage />,
      },
      {
        path: "/webshops",
        element: <WebshopsPage />,
      },
      {
        path: "/online-marketing",
        element: <OnlineMarketingPage />,
      },
      {
        path: "/seo",
        element: <SeoPage />,
      },
      {
        path: "/website-snelheid",
        element: <WebsiteSpeedPage />,
      },
      {
        path: "/app-dev",
        element: <AppDevPage />,
      },
      {
        path: "/support-and-optimization",
        element: <SupportAndOptimizationPage />,
      },
      {
        path: "/portfolio",
        element: <PortfolioPage />,
      },
      {
        path: "/about",
        element: <AboutUsPage />,
      },
      {
        path: "/contact",
        element: <ContactPage />,
      },
      {
        path: "/start-your-project",
        element: <StartProjectPage />,
      },
      {
        path: "/blog",
        element: <BlogPage />,
      },
      {
        path: "/blog/:slug",
        element: <BlogPostPage />,
      },
      {
        path: "/apps-privacybeleid",
        element: <AppsPrivacyPolicyListPage />,
      },
      {
        path: "/apps-privacybeleid/:appId",
        element: <AppsPrivacyPolicyDetailPage />,
      },
      {
        path: "/partner",
        element: <PartnerPage />,
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicyPage />,
      },

    ]
  },
]);

function App() {
  return (
    <div className="text-gray-800">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
